<template>
  <div>
    <wc-data-box title='Summary'>
      <v-card-text>
        <table width='100%'>
          <tr>
            <td>Subtotal</td>
            <td class='text-right'>{{ subtotal | decMoney }}</td>
          </tr>
          <tr>
            <td>GST</td>
            <td class='text-right'>{{ gst | decMoney }}</td>
          </tr>
          <tr>
            <td  colspan='2'>
              <v-divider class='my-2'></v-divider>
            </td>
          </tr>
          <tr class='headline'>
            <td>Total</td>
            <td class='text-right'>{{ total | decMoney }}</td>
          </tr>
        </table>
      </v-card-text>
    </wc-data-box>
  </div>
</template>

<script>
export default {
  name: 'expense-summary',
  props: {
    expense: {
      required: true
    },
    total: {
      required: false
    },
    subtotal: {
      required: false
    },
    gst: {
      required: false
    }
  }
}
</script>
